import {DownOutlined} from '@ant-design/icons';

import {DropdownWrapper} from '../CreatableMultiSelect.styled';

const DropdownIndicator = () => {
  return (
    <DropdownWrapper>
      <DownOutlined />
    </DropdownWrapper>
  );
};

export default DropdownIndicator;
